import React, { FC, useCallback, useEffect, useState } from 'react';
import { setClass, useStore, useViewModel } from '@utils';
import { isMobile } from 'react-device-detect';
import { observer } from 'mobx-react-lite';
import { CalendarColorsStore } from '../../store';
import { ProfileViewModel } from '@views';
import { Button } from '../button';
import { BlueArrowDown, Refresh } from '../svgs';
import { ConnectedCalendarField, NewCalendarField } from '../сalendarField';
import '../../styles/components/profileTabs.scss';

export const MyCalendarsTab: FC = observer(() => {
  const profileViewModel = useViewModel(ProfileViewModel);
  const calendarColorsStore = useStore(CalendarColorsStore);

  const [isOpen, setIsOpen] = useState(false);
  const [isRotate, setRotate] = useState(false);
  const [visibleCalendarUrls, setVisibleCalendarUrls] = useState([]);

  const updateVisibleCalendarUrls = (isOpen: boolean) => setVisibleCalendarUrls(
    profileViewModel.urls.length > 3 && !isOpen
      ? profileViewModel.urls.slice(0, 3)
      : profileViewModel.urls
  );

  const onOpenCalendarsList = useCallback(() => {
    setIsOpen((prev) => {
      setTimeout(
        () => updateVisibleCalendarUrls(!prev),
        prev ? 500 : 0,
      );
      return !prev;
    });
  }, []);

  const onSaveEditCalendar = () => {
    profileViewModel.onChangeApply()
      .then(() => updateVisibleCalendarUrls(isOpen));
  };

  const synchronization = useCallback(() => {
    setRotate(true);
    profileViewModel.synchronize();
  }, []);

  const isEmptyCalendars = profileViewModel.urls.length === 0;
  let interval: NodeJS.Timeout;

  useEffect(() => {
    !!calendarColorsStore.data.length && !profileViewModel.restoreNewCalendar && profileViewModel.hideConnectingCalendar();
    profileViewModel.initEditCalendar(null);
    profileViewModel.getSynchronizationStatus();
    interval = setInterval(() => {
      profileViewModel.getSynchronizationStatus()
        .then(() => {
          const { status } = profileViewModel.synchronizationStatus;
          if (status !== 'USER_SYNC_IS_RUNNING' && status !== 'OVERALL_SYNC_IS_RUNNING') {
            setRotate(false);
          }
        });
    }, 5000); // TODO: Переписать на вебсокеты.
    return () => clearInterval(interval);
  }, [calendarColorsStore.data.length]);

  useEffect(() => {
    updateVisibleCalendarUrls(isOpen);
  }, [profileViewModel.urls.length]);

  return (
    <div className={setClass(isMobile && 'mobile-wrapper')}>
      <h4 className="advanced-info">Мои календари</h4>
      <div className={setClass('calendar-list', isOpen && 'open', !!profileViewModel.editCalendar && 'edit-calendar')}>
        {visibleCalendarUrls.map((elem) => {
          const isChanging = profileViewModel.editCalendar?.id === elem.id;
          return (
            <ConnectedCalendarField
              getColor={profileViewModel.getColor}
              onChangeClick={profileViewModel.initEditCalendar}
              key={elem.id}
              colors={profileViewModel.colors}
              onDeleteCalendar={profileViewModel.deleteCalendar}
              calendar={isChanging ? profileViewModel.editCalendar : elem}
              isChanging={isChanging}
              onChange={profileViewModel.onChangeCalendar}
              onChangeApply={onSaveEditCalendar}
            />
          );
        })}
      </div>

      {profileViewModel.urls.length > 3 && (
        <BlueArrowDown divClassName={setClass('more-calendars-button', isOpen && 'open', isMobile && 'mobile')} onClick={onOpenCalendarsList} />
      )}

      {profileViewModel.isConnectNewCalendar
        ? (
          <NewCalendarField
            loading={profileViewModel.calendarLoading}
            getColor={profileViewModel.getColor}
            calendar={profileViewModel.newCalendar}
            colors={profileViewModel.colors}
            onChangeCalendar={profileViewModel.editNewCalendar}
            onSave={profileViewModel.connectNewUrl}
            onCancel={profileViewModel.switchNewCalendarVisibility}
            calendarProvider={profileViewModel.calendarProvider}
            onChangeCalendarProvider={profileViewModel.changeCalendarProvider}
            mailAuth={profileViewModel.mailAuth}
            changeMailAuth={profileViewModel.changeMailAuth}
            initAuth={profileViewModel.initAuthCalendar}
          />
        )
        : (
          <>
            <div className="big-button-area">
              <Button
                icon={<Refresh divClassName={setClass(isRotate && 'sync-rotator')} disabled={isEmptyCalendars} />}
                title="Обновить календари"
                disabled={isEmptyCalendars}
                className={setClass('outlined with-icon', isMobile ? 'mobile-button long' : 'medium-long')}
                onClick={synchronization}
              />
              <Button
                title="Добавить календарь"
                className={setClass('medium-long', isMobile && 'mobile-button')}
                onClick={profileViewModel.switchNewCalendarVisibility}
              />
            </div>
            <p
              className={setClass('synchronization-status-label', isMobile && 'mobile')}
            >
              {profileViewModel.syncStatusString}
            </p>
          </>
        )}
    </div>
  );
});
